module.exports = __webpack_public_path__ + "img/icon_filterWord.03b47d41.svg";